import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
const ProductListingSEOLinkedData = () => {
  const $ = _c(15);
  const {
    products,
    pageLongName,
    pageLongDescription,
    sortOrder,
    isFinalProductCountKnown,
    productCount,
    isAllDataLoading,
    pageId
  } = useProductListingPageContext();
  const {
    href
  } = useLocation();
  const t0 = isFinalProductCountKnown ? productCount : null;
  const t1 = pageLongDescription ?? "";
  const t2 = pageId ?? "";
  let t3;
  if ($[0] !== products) {
    t3 = products.map(_temp);
    $[0] = products;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== href || $[3] !== pageLongName || $[4] !== sortOrder || $[5] !== t0 || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      url: href,
      numberOfItems: t0,
      description: t1,
      identifier: t2,
      itemListElement: t3,
      itemListOrder: sortOrder,
      name: pageLongName
    };
    $[2] = href;
    $[3] = pageLongName;
    $[4] = sortOrder;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const jsonLD = t4;
  let t5;
  if ($[10] !== isAllDataLoading || $[11] !== jsonLD) {
    t5 = !isAllDataLoading && <script type="application/ld+json">{JSON.stringify(jsonLD)}</script>;
    $[10] = isAllDataLoading;
    $[11] = jsonLD;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <Helmet>{t5}</Helmet>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default ProductListingSEOLinkedData;
function _temp(product) {
  return {
    "@type": "Product",
    name: product?.name,
    sku: product?.variantsToShow[0]?.sku,
    image: product?.variantsToShow[0]?.image ?? "",
    description: product?.name,
    brand: "Joybird",
    offers: {
      "@type": "Offer",
      url: `https://joybird.com${product?.path}`,
      priceCurrency: "USD",
      price: product?.variantsToShow[0]?.price,
      availability: product?.variantsToShow[0]?.isOutOfStock ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
      itemCondition: "https://schema.org/NewCondition"
    }
  };
}